import axios from "../../../lib/axios";

export const all = async ({ commit }, payload) => {
  try {
    payload = payload || {};
    let params = payload.params || "sort=title";
    let res = await axios.get(`/pages?${params}`);
    commit("SET_ALL", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const create = async ({ commit }, payload) => {
  try {
    let res = await axios.post(`/pages`, payload);
    commit("CREATE", res.data);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const read = async ({ commit, state }, payload) => {
  let local = state.all.find(x => x._id === payload.id);
  commit("SET_ITEM", local);

  // get latest
  try {
    let res = await axios.get(`/pages/${payload.id}`);
    commit("SET_ITEM", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const publicRead = async ({ commit, state }, payload) => {
  let title = payload.page;
  let slug = title ? title.replace(/_/g, " ").toLowerCase() : null;

  if (state.all && state.all.length > 0) {
    let local = state.all.find(
      x =>
        x.title.toLowerCase() === slug ||
        (x.link ? x.link.toLowerCase() : "") === slug
    );
    commit("SET_ITEM", local);
  }

  // get latest
  try {
    let res = await axios.get(`/public/${payload.page}`);
    commit("SET_ITEM", res.data);

    // cache page
    let index = state.all.findIndex(x => x._id === res.data._id);
    if (index > -1) {
      state.all.splice(index, 1);
    }
    state.all.push(res.data);
    commit("SET_ALL", state.all);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const ogl = async ({ commit, state }) => {
  let slug = "Open_Game_License";

  if (state.all && state.all.length > 0) {
    let local = state.all.find(
      x =>
        x.title.toLowerCase() === slug ||
        (x.link ? x.link.toLowerCase() : "") === slug
    );
    commit("SET_OGL", local);
  }

  // get latest
  try {
    let res = await axios.get(`/public/${slug}`);
    commit("SET_OGL", res.data);

    // cache page
    let index = state.all.findIndex(x => x._id === res.data._id);
    if (index > -1) {
      state.all.splice(index, 1);
    }
    state.all.push(res.data);
    commit("SET_ALL", state.all);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const navigation = async ({ commit }) => {
  // get latest
  try {
    let res = await axios.get(`/public/Navigation`);
    commit("SET_NAVIGATION", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const edit = async ({ commit, state }, payload) => {
  let local = state.all.find(x => x._id === payload.id);
  commit("SET_ITEM", local);

  // get latest
  try {
    let res = await axios.get(`/pages/${payload.id}`);
    commit("SET_ITEM", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const update = async ({ commit, state }) => {
  try {
    let res = await axios.patch(`/pages/${state.current._id}`, state.current);
    commit("UPDATE", res.data);
    commit("SET_ITEM", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const clone = async ({ commit, state }) => {
  try {
    let clone = JSON.parse(JSON.stringify(state.current));
    delete clone._id;
    if (clone.title) {
      clone.title = `${clone.title} (Copy)`;
    }
    let res = await axios.post(`/pages`, clone);
    commit("CREATE", res.data);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const destroy = async ({ commit, state }) => {
  try {
    await axios.delete(`/pages/${state.current._id}`);
    commit("DELETE", state.current);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};
